import { render, staticRenderFns } from "./SingleNumberFrameAverageSessionsPerPassenger.vue?vue&type=template&id=01ecf47e&"
import script from "./SingleNumberFrameAverageSessionsPerPassenger.vue?vue&type=script&lang=js&"
export * from "./SingleNumberFrameAverageSessionsPerPassenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports